"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATICUnfiToken = exports.MATICUpToken = exports.MATICWrappedToken = exports.MATICNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.MATICNativeToken = new utils_1.Currency("MATIC", 18, "MATIC", "MATIC");
exports.MATICWrappedToken = new utils_1.Currency("0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270", 18, "WMATIC", "WMATIC");
exports.MATICUpToken = new utils_1.Currency("0x49b4d34edcc985fea2a8fbcc11ec575283d10d87", 18, "UP", "UP");
exports.MATICUnfiToken = new utils_1.Currency("0xed6072Ef5032484c2CC5f76630310e4BD36e62d2", 18, "UNFI", "UNFI");
